module.exports = __webpack_public_path__ + "img/gas02_play.6fd1ba95.gif";